<template>
   <map-marker :width="32" :height="32"
			   :lat-lng="props.latLng"
			   @click="emit('click')"
			   :image="$image.format(props.participation.avatar_thumbnail, {width: (32 * 2), height: (32 * 2)})"
			   :color="markerColor"
			   :z-index="props.focused ? 2 : 1"/>
</template>

<script setup lang="ts">
import type {ActivityLatLng} from "@spoferan/spoferan-ts-core";
import {useNuxtApp} from '#app';
import {computed} from 'vue';

const props = withDefaults(defineProps<{
	participation: object,

	latLng?: ActivityLatLng,

	// Whether the element shall retrieve a focused styling
	// Null when neutral, boolean when focused or not
	focused?: boolean,

	color?: string,
}>(), {
	color: '#47a447'
});
const emit = defineEmits(['click']);

const {$date} = useNuxtApp();

const markerColor = computed(() => {
	if (props.participation.ranks && props.participation.ranks.length) {
		switch (props.participation.ranks[0].rank) {
			case 1:
				return '#AF9500';
			case 2:
				return '#B4B4B4';
			case 3:
				return '#AD8A56';
		}
	}

	return props.focused === true || props.focused === null ? props.color : '#7D8484';
});

</script>